var Web3 = require('web3');

import {
  wiseContractAddress,
  wiseContractABI
} from "./contract_mainnet_staking_1_0x66a0f676479Cee1d7373f3DC2e2952778BfF5bd6"

var wiseContract = null;
var web3 = null;
var infuraWiseContract = null;
var infuraWeb3 = null;

async function createContract() {
  web3 = new Web3(window.ethereum);
  await window.ethereum.enable();

  wiseContract = await new web3.eth.Contract(wiseContractABI, wiseContractAddress);
}

async function createInfuraMainnetContract() {

  var options = {
    timeout: 30000, // ms
    clientConfig: {
      maxReceivedFrameSize: 100000000,   // bytes - default: 1MiB
      maxReceivedMessageSize: 100000000, // bytes - default: 8MiB
    },
    reconnect: {
        auto: true,
        delay: 5000, // ms
        maxAttempts: 5,
        onTimeout: false
    }
  };

  let wsUrl = "wss://mainnet.infura.io/ws/v3/3b2691844ac84f1fb3e3f977da761c42";
  infuraWeb3 = new Web3(new Web3.providers.WebsocketProvider(wsUrl, options));
  infuraWiseContract = await new infuraWeb3.eth.Contract(wiseContractABI, wiseContractAddress);
}


export async function getWeb3() {
  if (web3 === null) {
    // console.log("web3 does not exist -> createContract");
    await createContract();
  } else {
    // console.log("web3 available");
  }
  return web3;
}

export async function getWiseContract() {
  if (wiseContract === null) {
    // console.log("wiseContract does not exist -> createContract");
    await createContract();
  } else {
    // console.log("contract available");
  }
  return wiseContract;
}

export async function getInfuraWeb3() {
  if (infuraWeb3 === null) {
    // console.log("web3 does not exist -> createContract");
    await createInfuraMainnetContract();
  } else {
    // console.log("web3 available");
  }
  return infuraWeb3;
}

export async function getInfuraWiseContract() {
  if (infuraWiseContract === null) {
    // console.log("wiseContract does not exist -> createContract");
    await createInfuraMainnetContract();
  } else {
    // console.log("contract available");
  }
  return infuraWiseContract;
}
